<template>
    <div ref="top">
        <div class="mb-5">
            Thanks for Your Question! We have received your message and will reply as soon as we have your answer ready.
        </div>
    </div>
</template>

<script>

export default {
    props: {
        question: {
            type: Object,
            required: true
        }
    },
}
</script>
